import { createFileRoute } from '@tanstack/react-router';

import { CredentialsUpdateRoot } from '@/features/credentials/components/CredentialsUpdateRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import {
  AppPageHeader,
  BreadcrumbItemProps,
} from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/_app/app/admin-section/credentials')({
  component: CredentialsComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },
  {
    label: 'Credentials',
    link: { to: '/app/admin-section/credentials' },
  },
];

function CredentialsComponent() {
  return (
    <AppPageContent>
      <AppPageHeader breadcrumbItems={breadcrumbItems} />
      <CredentialsUpdateRoot />
    </AppPageContent>
  );
}
